export const APIEvent = {
  ADD_NOTE: 'addNote',
  ADD_MESSAGE: 'addMessage',
  ADD_TENANT_GROUP: 'addTenantGroup',
  ADD_TENANT_TO_GROUP: 'addTenantToGroup',
  ADD_USER: 'addUser',
  CANCEL_ENG_BOOKING: 'cancelEngineerBooking',
  CHANGE_PWD: 'changePassword',
  CHECK_OTP: 'checkOTP',
  CREATE_ENG_BOOKING: 'createEngineerBooking',
  DELETE_TENANT_GROUP: 'deleteTenantGroup',
  DELETE_TENANT_FROM_GROUP: 'deleteTenantFromGroup',
  LOGIN: 'login',
  SSO_LOGIN: 'sso_login',
  EXCHANGE_ID_TOKEN: 'exchange_id_token',
  LOGOUT: 'logout',
  EDIT_ENG_BOOKING: 'editEngineerBooking',
  FETCH_ACCOUNT: 'fetchAccount',
  FETCH_DERIVED_EVENTS: 'fetchDerivedEvents',
  FETCH_DERIVED_EVENTS_VIEW: 'fetchDerivedEventsView',
  FETCH_CUSTOMER_FEEDBACK: 'fetchCustomerFeedBack',
  FETCH_COST_OF_PROGRAMME: 'fetchCostOfProgramme',
  FETCH_WORK_ORDER_CLAIM_SAVINGS: 'fetchWorkOrderClaimSavings',
  FETCH_LEAK_CATEGORIES: 'fetchLeakCategories',
  FETCH_DAMAGE_CAUSING_REPAIRS: 'fetchDamageCausingRepairs',
  FETCH_REPAIRS: 'fetchRepairs',
  FETCH_LOW_LEAK_ALERTS: 'fetchLowLeakAlerts',
  FETCH_MARKETING_METRICS: 'fetchMarketingMetrics',
  FETCH_ORDERS_AND_REGISTRATIONS: 'fetchOrdersAndRegistrations',
  FETCH_MONTHLY_REGISTRATIONS: 'fetchMonthlyRegistrations',
  FETCH_DEVICE: 'fetchDevice',
  FETCH_DEVICES: 'fetchDevices',
  FETCH_DEVICE_MESSAGES: 'fetchDeviceMessages',
  FETCH_DONUTS: 'fetchDonuts',
  FETCH_INSTALLS_DONUT: 'fetchInstallsDonut',
  FETCH_ENG_BOOKING: 'fetchEngineerBooking',
  FETCH_LANGUAGE_LIST: 'fetchLanguageList',
  FETCH_LEAK_LIST: 'fetchLeakList',
  FETCH_REMOVED_DEVICES_LIST: 'fetchRemovedDevicesList',
  FETCH_EVENT_LIST: 'fetchEventList',
  FETCH_GROUP_TENANTS: 'fetchGroupTenants',
  USER_TENANT_LIST: 'userTenantList',
  FETCH_INCOMPLETE_INSTALLS_LIST: 'fetchIncompleteInstallsList',
  FETCH_MESSAGE: 'fetchMessage',
  FETCH_MESSAGE_LIST: 'fetchMessageList',
  FETCH_MESSAGE_TYPES: 'fetchMessageTypes',
  FETCH_NOTES: 'fetchNotes',
  FETCH_TENANTS: 'fetchTenants',
  FETCH_TENANT: 'fetchTenant',
  FETCH_TENANT_INFO: 'fetchTenantInfo',
  UPDATE_TENANT_INFO: 'updateTenantInfo',
  FETCH_CAMPAIGN_ID: 'fetchCampaignID',
  ADD_TENANT: 'addTenant',
  FETCH_TENANT_GROUPS: 'fetchTenantGroups',
  FETCH_USER_COMMS: 'fetchCommsHistory',
  FETCH_USER_EMAIL: 'fetchUserEmail',
  FETCH_USER_ROLES: 'fetchUserRoles',
  FETCH_USERS: 'fetchUsers',
  FETCH_WATER_USAGE: 'fetchWaterUsage',
  MARK_REPAIRED: 'markAsLeakRepaired',
  REMOVE_DEVICE_FROM_USER: 'removeDeviceFromUser',
  RESET_PWD: 'resetPassword',
  RESET_2FA: 'reset2FA',
  SEARCH: 'search',
  UPDATE_ACCOUNT: 'updateAccount',
  UPDATE_ADDRESS: 'updateAddress',
  UPDATE_DEVICE: 'updateDevice',
  UPDATE_MESSAGE: 'updateMessage',
  UPDATE_VIP: 'updateVip',
  FETCH_TOKEN: 'fetchToken',
  DISABLE_INSTALL_CHASERS: 'disableInstallChasers',
  // USED FOR DEV
  UPDATE_TENANT_GROUP: 'updateTenantGroup',
  UPDATE_USER_TENANT_GROUP: 'updateUserTenantGroup',
  FETCH_PARAMETERS: 'fetchParameters',
  MATLAB_PARAMETER_LIST: 'matlabParameterList',
  MATLAB_PARAMETER_ADD: 'matlabParameterAdd',
  MATLAB_PARAMETER_UPDATE: 'matlabParameterUpdate',
  MATLAB_DEVICE_PARAMETERS: 'matlabDeviceParameters',
  MATLAB_DEVICE_UPDATE: 'matlabDeviceUpdate',
  CREATE_PARAMETER_UPDATE: 'createParameterUpdate',
  INSTALL_ENVIRONMENT: 'installEnvironment',
  FETCH_API: 'fetchAPI',
  FETCH_ROLE_API: 'fetchRoleApi',
  FETCH_ROLE_APIS: 'fetchRoleApis',
  ADD_API_TO_ROLE: 'addApiToRole',
  ADD_ROLE_TO_API: 'addRoleToApi',
  REMOVE_API_FROM_ROLE: 'removeApiFromRole',
  CREATE_ROLE: 'createRole',
  // USED IN DEV
  CLEAR: 'clear'
}
